/**
 * "Connect a client" — MCP section (ADR-0074).
 * Reconciled from the dashboard MCP page (connection URL + per-client setup) and
 * the .mcpb / copy-config flows.
 */
import type { DocPageContent } from '../types';

const CURSOR = `{
  "mcpServers": {
    "syncanix": {
      "url": "https://mcp.syncanix.com/v1/<your-workspace>"
    }
  }
}`;

export const MCP_CONNECT_PAGE: DocPageContent = {
  slug: 'mcp/connect',
  titleKey: 'docs.mcp.connect.title',
  descriptionKey: 'docs.mcp.connect.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.mcp.connect.lead' },

    { kind: 'heading', level: 2, id: 'find', textKey: 'docs.mcp.connect.find.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.connect.find.body' },

    { kind: 'heading', level: 2, id: 'claude', textKey: 'docs.mcp.connect.claude.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.connect.claude.body' },

    { kind: 'heading', level: 2, id: 'cursor', textKey: 'docs.mcp.connect.cursor.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.connect.cursor.body' },
    { kind: 'code', language: 'json', code: CURSOR },

    { kind: 'heading', level: 2, id: 'chatgpt', textKey: 'docs.mcp.connect.chatgpt.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.connect.chatgpt.body' },

    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.mcp.connect.signin.title',
      textKey: 'docs.mcp.connect.signin.body',
      links: {
        auth: {
          target: { docSlug: 'mcp/authentication' },
          labelKey: 'docs.mcp.connect.signin.link',
        },
      },
    },

    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.mcp.connect.resources.title',
      textKey: 'docs.mcp.connect.resources.body',
      links: {
        mcp: {
          target: { href: 'https://modelcontextprotocol.io', external: true },
          labelKey: 'docs.mcp.connect.resources.link.mcp',
        },
        claude: {
          target: { href: 'https://support.claude.com', external: true },
          labelKey: 'docs.mcp.connect.resources.link.claude',
        },
        cursor: {
          target: { href: 'https://docs.cursor.com', external: true },
          labelKey: 'docs.mcp.connect.resources.link.cursor',
        },
        chatgpt: {
          target: { href: 'https://help.openai.com', external: true },
          labelKey: 'docs.mcp.connect.resources.link.chatgpt',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.mcp.connect.next.auth.title',
          textKey: 'docs.mcp.connect.next.auth.text',
          to: { docSlug: 'mcp/authentication' },
        },
        {
          titleKey: 'docs.mcp.connect.next.tools.title',
          textKey: 'docs.mcp.connect.next.tools.text',
          to: { docSlug: 'mcp/tools' },
        },
      ],
    },
  ],
};
